import { fork, put } from 'redux-saga/effects';

import artisansSaga from '../modules/artisans/Saga';
import suppliersSaga from '../modules/suppliers/Saga';
import customersSaga from '../modules/customers/Saga';
import artisanCategoriesSaga from '../modules/artisanCategories/Saga';
// Job Categories
import artisanJobCategoriesSaga from '../modules/artisanJobCategories/Saga';
import supplierJobCategoriesSaga from '../modules/supplierJobCategories/Saga';

import artisanProductsSaga from '../modules/artisanProducts/Saga';
import supplierProductsSaga from '../modules/supplierProducts/Saga';

import artisanTagsSaga from '../modules/artisanTags/Saga';
import supplierTagsSaga from '../modules/supplierTags/Saga';

// Jobs
import artisanJobsSaga from '../modules/artisanJobs/Saga';
import applicantJobsSaga from '../modules/applicantJobs/Saga';
import supplierJobsSaga from '../modules/supplierJobs/Saga';

import supplierCategoriesSaga from '../modules/supplierCategories/Saga';
import authSaga from '../modules/auth/Saga';
import usersSaga from '../modules/users/Saga';

import pendingCustomersSaga from '../modules/customersModearion/customers/Saga';
import pendingApplicantsSaga from '../modules/applicantsModearion/applicants/Saga';
import pendingArtisansSaga from '../modules/artisanModeration/artisans/Saga';
import pendingSuppliersSaga from '../modules/supplierModeration/suppliers/Saga';

import pendingArtisanProductsSaga from '../modules/artisanModeration/artisanProducts/Saga';
import pendingSupplierProductsSaga from '../modules/supplierModeration/supplierProducts/Saga';

// Job Moderation
import pendingArtisanJobsSaga from '../modules/artisanModeration/artisanJobs/Saga';
import pendingSupplierJobsSaga from '../modules/supplierModeration/supplierJobs/Saga';

import artisanPublicInquiriesSaga from '../modules/inquiries/artisans/public/Saga';
import pendingArtisanPublicInquirySaga from '../modules/artisanModeration/publicInquiry/Saga';

import artisanPrivateInquiriesSaga from '../modules/inquiries/artisans/private/Saga';
import pendingArtisanPrivateInquirySaga from '../modules/artisanModeration/privateInquiry/Saga';
import pendingSupplierPrivateInquirySaga from '../modules/supplierModeration/privateInquiry/Saga';
import pendingSupplierPublicInquirySaga from '../modules/supplierModeration/publicInquiry/Saga';

import supplierPrivateInquiriesSaga from '../modules/inquiries/suppliers/private/Saga';
import supplierPublicInquiriesSaga from '../modules/inquiries/suppliers/public/Saga';

import usersReportsSaga from '../modules/reports/users/Saga';
import artisansReportsSaga from '../modules/reports/artisans/Saga';
import suppliersReportsSaga from '../modules/reports/suppliers/Saga';

import suppliersCategoriesReportsSaga from '../modules/reports/suppliersCategories/Saga';
import artisansCategoriesReportsSaga from '../modules/reports/artisansCategories/Saga';
import suppliersTagsReportsSaga from '../modules/reports/suppliersTags/Saga';
import artisansTagsReportsSaga from '../modules/reports/artisansTags/Saga';

import artisanFollowerList from '../modules/FollowersList/Artisan/Saga';
import supplierFollowerList from '../modules/FollowersList/Supplier/Saga';

// import artisanJobsSaga from '../modules/jobs/Artisan/Saga';
// import supplierJobsSaga from '../modules/jobs/Supplier/Saga';

import myArtisanProductsListSaga from '../modules/myProductList/Artisan/Saga';
import mySupplierProductsListSaga from '../modules/myProductList/Supplier/Saga';

import myArtisanPrivateInquiriesSaga from '../modules/myInquiries/Artisan/Private/Saga';
import mySupplierPrivateInquiriesSaga from '../modules/myInquiries/Supplier/Private/Saga';

import myArtisanPublicInquiriesSaga from '../modules/myInquiries/Artisan/Public/Saga';
import mySupplierPublicInquiriesSaga from '../modules/myInquiries/Supplier/Public/Saga';

import customerFavArtisanProductsSaga from '../modules/customerFavArtisanProducts/Saga';
import customerFavSupplierProductsSaga from '../modules/customerFavSupplierProducts/Saga';
import customerArtisanFollowingListSaga from '../modules/customerFollowingArtisanList/Saga';
import customerSupplierFollowingListSaga from '../modules/customerFollowingSupplierList/Saga';
import customerLimitSaga from '../modules/customerLimits/Saga';
import applicantSaga from '../modules/applicants/Saga';
import pendingArtisanProposals from '../modules/artisanModeration/privateProposals/Saga';
import pendingSupplierProposals from '../modules/supplierModeration/privateProposals/Saga';
import PendingPublicArtisanProposals from '../modules/artisanModeration/publicProposals/Saga';
import PendingPublicSupplierProposals from '../modules/supplierModeration/publicProposals/Saga';
import statistics from '../modules/statistics/Saga';

import trainingCenterSaga from '../modules/trainingCenter/Saga';
import { appReadyAction } from './globalActions';

export default function*() {
  yield fork(authSaga);
  yield fork(usersSaga);
  yield fork(artisansSaga);
  yield fork(suppliersSaga);
  yield fork(customersSaga);
  yield fork(artisanCategoriesSaga);
  yield fork(artisanJobCategoriesSaga);
  yield fork(supplierJobCategoriesSaga);
  yield fork(artisanProductsSaga);
  yield fork(supplierProductsSaga);
  yield fork(supplierCategoriesSaga);
  yield fork(artisanTagsSaga);
  yield fork(supplierTagsSaga);

  yield fork(pendingCustomersSaga);
  yield fork(pendingApplicantsSaga);
  yield fork(pendingArtisansSaga);
  yield fork(pendingSuppliersSaga);

  yield fork(artisanPublicInquiriesSaga);
  yield fork(artisanPrivateInquiriesSaga);

  yield fork(supplierPrivateInquiriesSaga);
  yield fork(supplierPublicInquiriesSaga);

  yield fork(pendingArtisanProductsSaga);
  yield fork(pendingSupplierProductsSaga);

  // Job Moderation
  yield fork(pendingArtisanJobsSaga);
  yield fork(pendingSupplierJobsSaga);

  yield fork(pendingArtisanPrivateInquirySaga);
  yield fork(pendingArtisanPublicInquirySaga);

  yield fork(pendingSupplierPrivateInquirySaga);
  yield fork(pendingSupplierPublicInquirySaga);

  yield fork(usersReportsSaga);
  yield fork(artisansReportsSaga);
  yield fork(suppliersReportsSaga);

  yield fork(artisansTagsReportsSaga);
  yield fork(artisansCategoriesReportsSaga);

  yield fork(suppliersTagsReportsSaga);
  yield fork(suppliersCategoriesReportsSaga);

  yield fork(artisanFollowerList);
  yield fork(supplierFollowerList);

  yield fork(artisanJobsSaga);
  yield fork(applicantJobsSaga);
  yield fork(supplierJobsSaga);
  // yield fork(supplierJobsSaga);

  yield fork(myArtisanProductsListSaga);
  yield fork(mySupplierProductsListSaga);

  yield fork(myArtisanPrivateInquiriesSaga);
  yield fork(mySupplierPrivateInquiriesSaga);

  yield fork(myArtisanPublicInquiriesSaga);
  yield fork(mySupplierPublicInquiriesSaga);

  yield fork(customerArtisanFollowingListSaga);
  yield fork(customerSupplierFollowingListSaga);

  yield fork(customerFavArtisanProductsSaga);
  yield fork(customerFavSupplierProductsSaga);

  yield fork(PendingPublicArtisanProposals);
  yield fork(PendingPublicSupplierProposals);

  yield fork(applicantSaga);
  yield fork(trainingCenterSaga);
  yield fork(pendingArtisanProposals);
  yield fork(pendingSupplierProposals);
  yield fork(customerLimitSaga);
  yield fork(statistics);
  yield put(appReadyAction());
}
